<template>
  <div class="flex flex-col items-center justify-center min-h-screen px-6 py-8 mx-auto lg:py-0">
      <div class="w-full bg-white rounded-lg shadow dark:border sm:max-w-md dark:bg-gray-800 dark:border-gray-700">
          <div class="p-6 space-y-4 sm:space-y-6">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white text-center">
                  Sign in to your account
              </h1>
              <v-form class="space-y-4 sm:space-y-6" @submit.prevent="login">
                  <div>
                      <label for="username" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Username</label>
                      <input variant="underlined" v-model="input.username" :rules="usernameRules" type="text" name="username" id="username" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="product_manager_01@company.com">
                  </div>
                  <div>
                      <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <div class="relative">
                        <input variant="underlined" v-model="input.password" :rules="passwordRules" :type="showPassword ? 'text' : 'password'" name="password" id="password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 pr-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <button type="button" tabindex="-1" @click="showPassword = !showPassword" class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 dark:text-gray-300 dark:hover:text-gray-100" :title="showPassword ? 'Hide password' : 'Show password'">
                          <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
                        </button>
                      </div>
                  </div>
                  <!-- Alert Section -->
                  <div v-if="responseMessage !== ''"  class="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                    <svg class="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                    </svg>
                    <span class="sr-only">Info</span>
                    <div>
                      <span class="font-medium">Login Failed!</span> {{ responseMessage }}.
                    </div>
                  </div>
                  <!-- End Alert Section -->
                  <div class="flex items-center justify-between">
                      <div class="flex items-start">
                          <div class="flex items-center h-5">
                              <input id="remember" aria-describedby="remember" type="checkbox" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800">
                          </div>
                          <div class="ml-3 text-sm">
                              <label for="remember" class="text-gray-500 dark:text-gray-300">Remember me</label>
                          </div>
                      </div>
                      <router-link to="/forgot-password" class="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500">Forgot password?</router-link>
                  </div>
                  <button type="submit" class="w-full px-4 py-2 text-white bg-indigo-600 rounded-md hover:bg-indigo-700">Sign in</button>
              </v-form>
          </div>
      </div>
  </div>

  <ForceChangePasswordModal
    :visible="showForceChange"
    :username="forcedUsername"
    @password-changed="handlePasswordChanged"
  />
</template>

<script>

import axios from "axios";
import store from '../store';
import ForceChangePasswordModal from '@/components/ForceChangePasswordModal.vue';
export default {
  components: { ForceChangePasswordModal },
  data() {
    return {
      input: {
        username: "",
        password: "",
      },
      showAlert: false,
      responseMessage: '',
      alertClass: '',
      usernameRules: [(v) => !!v || 'Username is required'],
      passwordRules: [(v) => !!v || 'Password is required'],
      showModal: false,
      showForceChange: false,
      forcedUsername: '',
      showPassword: false,
    };
  },
  methods: {
    async login() {
      this.responseMessage = '';
      this.showAlert = false;
      if (this.input.username.length > 0 && this.input.password.length > 0)
        try {
          const response = await axios.post(
            process.env.VUE_APP_BASE_API + "/api/login/checklogin",
            {
              username: this.input.username,
              password: this.input.password,
            }
          );
          if (response.data && response.data.data) {
            await store.dispatch(`login`, response.data.data);
            const mustChange = !!response.data.data.mustChangePassword;
            if (mustChange) {
              this.forcedUsername = response.data.data.username || this.input.username;
              this.showForceChange = true;
              return;
            }
            this.redirectByRole();
          } else {
            this.responseMessage = 'Invalid username or password';
            this.alertClass = 'p-4 mb-4 text-sm text-green-700 bg-red-100 rounded-lg dark:bg-green-200 dark:text-green-800';
            this.showAlert = true;
          }
        } catch (error) {
          console.error("Login error:", error);
            this.responseMessage = 'Invalid username or password';
            this.alertClass = 'p-4 mb-4 text-sm text-green-700 bg-red-100 rounded-lg dark:bg-green-200 dark:text-green-800';
            this.showAlert = true;
        }
    },
    redirectByRole() {
      const loginRole = store.getters.role;
      if (loginRole === 'admin') {
        this.$router.push('/sale/dashboard').then(() => { window.location.reload(); });
      } else if (loginRole === 'pm') {
        this.$router.push('/productMaster/dashboard').then(() => { window.location.reload(); });
      } else if (loginRole === 'sale') {
        this.$router.push('/sale/dashboard').then(() => { window.location.reload(); });
      } else if (loginRole === 'cs') {
        this.$router.push('/cs/searchproducts').then(() => { window.location.reload(); });
      } else {
        this.responseMessage = 'Login successful';
        this.alertClass = 'p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800';
        this.showAlert = true;
      }
    },
    handlePasswordChanged() {
      this.showForceChange = false;
      this.redirectByRole();
    },
    closeModal() {
      this.showModal = false;
    }
  },
};
</script>

<style>
/* Add any custom styles here */
</style>
